import React, { useEffect, useState } from "react";
import styles from './subCategories.module.css'
import ProductTable from '../../components/OtherComps/ProductTable/ProductTable'
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getProductcountThunk, getProductThunk, resetProductStatusAndStock, setProductAppliedFilters, setProductFilter, setProductInstock, setProductPage, setProductStatus } from "../../redux/productSlice";
import SearchProduct from "./SearchProduct";
import ProductFilter from "./ProductFilter";
import SortProduct from "./SortProduct";
import CatPagination from "../../utils/Pagination";
import { addToCartThunk } from "../../redux/cartSlice";
import { addToScheduleThunk } from "../../redux/ScheduleSlice";
import { toggleProductSelection } from "../../redux/compareSlice";
import { setLoginpopup } from "../../redux/customerSlice";

const ProductList = () => {

    const dispatch = useDispatch();
    const { id } = useParams();
    const navigate = useNavigate()
    const { products, loading, page, filter, productCount, appliedFilters, search, status, stock } = useSelector(state => state.products)
    const { selectedData } = useSelector(state => state.compare)
    const [quantities, setQuantities] = useState({});
    const [cartLoading, setLoadingCart] = useState({});
    const [scheduleLoading, setScheduleloading] = useState({})
    const { isLoggedin } = useSelector((state) => state.customer)
    const [limit, setLimit] = useState(10)

    const product = products?.data
    const totalPages = products?.totalPages
    const totalItems = products?.totalItems
    const itemsPerPage = products?.limit
    const filterData = products?.filters || []


    // calculate start & end of items -------------------
    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;


    useEffect(() => {
        const data = {
            categoryId: id,
            page,
            limit,
            filters: appliedFilters,
            status,
            stock
        }
        dispatch(getProductThunk(data))
    }, [page, limit, appliedFilters, id])

    const handleSearch = () => {
        const data = {
            categoryId: id,
            page,
            limit,
            filters: appliedFilters,
            search,
            status,
            stock
        }
        dispatch(getProductThunk(data))
    }

    // Handle quantity change for a specific product
    const handleQuantityChange = (productId, value) => {
        setQuantities((prev) => ({
            ...prev,
            [productId]: value,
        }));
    };


    const addtoCart = async (from, productId) => {

        if (!isLoggedin) {
            return dispatch(setLoginpopup(true))
        }
        const products = Object.entries(quantities).map(([id, quantity]) => ({
            productId: id,
            totalQty: parseInt(quantity, 10),
            quantity: parseInt(quantity, 10),
        }));
        if (from == 'cart') {
            setLoadingCart((prev) => ({ ...prev, [productId]: true }));
            const status = await dispatch(addToCartThunk(products))
            if (status?.payload === 200) {
                // navigate('/cart')
                setQuantities({})
            }
            setLoadingCart((prev) => ({ ...prev, [productId]: false }));
        }
        else {
            setScheduleloading((prev) => ({ ...prev, [productId]: true }));
            const status = await dispatch(addToScheduleThunk(products))

            if (status?.payload === 200) {
                // navigate('/scheduleCart')
                setQuantities({})
            }
            setScheduleloading((prev) => ({ ...prev, [productId]: false }));
        }
    }



    // const handleCheckboxChange = (productId, isChecked) => {
    //     setQuantities((prevState) => {
    //         const updatedProducts = { ...prevState };

    //         if (isChecked) {
    //             updatedProducts[productId] = updatedProducts[productId] || 1;
    //         } else {
    //             delete updatedProducts[productId];
    //         }

    //         return updatedProducts;
    //     });
    // };



    // const handleCheckboxChange = (product, isChecked) => {
    //     setSelectedProducts((prevState) => {
    //         if (isChecked) {
    //             return [...prevState, product];
    //         } else {
    //             return prevState.filter((p) => p._id !== product._id);
    //         }
    //     });
    // };

    const handleCheckboxChange = (product) => {
        dispatch(toggleProductSelection(product));
    };


    const handleFilterChange = (filters) => {
        dispatch(setProductFilter(filters || []))
    };

    useEffect(() => {
        const data = {
            categoryId: id,
            filters: filter,
            stock,
            status
        }
        dispatch(getProductcountThunk(data))
    }, [filter, id, stock, status])


    const handleApply = () => {
        dispatch(setProductAppliedFilters(filter))
        // dispatch(setProductFilter([]))
    }

    const handleCheckboxchange = (from) => {
        if (from == 'stock') {
            return dispatch(setProductInstock())
        }
        dispatch(setProductStatus())
    }

    const handleReset = () => {
        dispatch(resetProductStatusAndStock());
        const data = {
            categoryId: id,
            page: 1,
            limit,
            filters: [],
            status: false,
            stock: false,
            search: ""
        };
        dispatch(getProductThunk(data));
    };

    return (
        <>

            <>

                <SearchProduct products={product || []} handleSearch={handleSearch} search={search} />
                <ProductFilter
                    filterData={filterData}
                    onFilterChange={handleFilterChange}
                    filter={filter}
                    count={productCount?.data?.filteredCount}
                    loading={productCount?.loading}
                    handleSubmit={handleApply}
                    handleCheckboxchange={handleCheckboxchange}
                    stock={stock}
                    status={status}
                    totalItems={totalItems}
                    handleReset={handleReset}
                    search={search}
                />

                <div className={styles.sortedTable}>
                    <SortProduct
                        filteredCount={productCount?.data?.filteredCount}
                        totalItems={totalItems}
                        loading={productCount?.loading}
                        filter={filter}
                        stock={stock}
                        status={status}
                    />

                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '60px 0' }}>
                            <img src="/assets/__Iphone-spinner-1.gif" alt="Loading..." style={{ width: 35, height: 35 }} />
                        </div>
                    ) : product?.length > 0 ? (
                        <>
                            <ProductTable
                                products={product}
                                quantities={quantities}
                                addtoCart={addtoCart}
                                handleQuantityChange={handleQuantityChange}
                                handleCheckboxChange={handleCheckboxChange}
                                cartLoading={cartLoading}
                                scheduleLoading={scheduleLoading}
                                selectedProducts={selectedData}
                                hide={'hide'}
                            />

                            <CatPagination
                                start={start}
                                end={end}
                                totalItems={totalItems}
                                itemsPerPage={itemsPerPage}
                                setPage={setProductPage}
                                page={page}
                            />
                        </>
                    ) : (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '40px 0' }}>
                            No Products found
                        </div>
                    )}
                </div>
            </>
        </>
    )
}

export default ProductList